export type EventStatus = 'upcoming' | 'ongoing' | 'past' | 'unknown'

export function computeStatus(
    startAt: string | null,
    endAt: string | null,
    now: number = Date.now()
): EventStatus {
    if (!startAt) return 'unknown'
    const start = new Date(startAt).getTime()
    if (Number.isNaN(start)) return 'unknown'
    if (now < start) return 'upcoming'
    if (!endAt) return 'ongoing'
    const end = new Date(endAt).getTime()
    if (now > end) return 'past'
    return 'ongoing'
}
